import { currentApp, currentQQ } from './primitive-selector'

const isInsuredAlsoPayer = (state) => !currentApp('payer')(state)

export const note = (state) => ({
  productCategory: currentQQ('selectedDisplayProduct.category')(state),
  isInsuredAlsoPayer: isInsuredAlsoPayer(state),
  isRemoteSelling: currentApp('isRemoteSelling')(state),
})
